export const PrintableCalendarWeekdays = [
  {
    name: "Sun-Sat",
    value: [0, 1, 2, 3, 4, 5, 6]
  },
  {
    name: "Mon-Sun",
    value: [1, 2, 3, 4, 5, 6, 0]
  }
]